export default {
    rotatable: true,
    resizableSides: []
}
